import React from 'react';

export default function CommunicationsPageHeader({ title, subtitle, action, secondaryAction }) {
  return (
    <div className="communications-dashboard-top">
      <div className="page-header page-header--communications">
        <div className="page-header-left">
          <h1 className="page-title">{title}</h1>
          {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
        </div>
        <div className="page-header-actions">
          {secondaryAction}
          {action}
        </div>
      </div>
    </div>
  );
}
